import classNames from 'classnames';
import React, { useState } from 'react';
import { useOnMount } from 'tradera/hooks/use-on-mount';

import type { PriceLabelProps } from './price-label';
import { PriceLabel } from './price-label';

export const AnimatedPriceLabel = ({
    className,
    ...props
}: PriceLabelProps) => {
    const [showAnimation, setShowAnimation] = useState(false);
    useOnMount(() => {
        setShowAnimation(true);
        const timer = setTimeout(() => {
            setShowAnimation(false);
        }, 500);
        return () => clearTimeout(timer);
    });
    const priceLabelProps = {
        ...props,
        className: classNames(
            {
                'item-card-details-price-highlight': showAnimation
            },
            className
        )
    };
    return <PriceLabel {...priceLabelProps} />;
};
